module.exports = __webpack_public_path__ + "images/458042f5ff569d5aace0516166c59eba.svg";